export const handleInputNumber = (event) => {
  event.target.value = event.target.value.replace(/[^0-9]/g, "");
};

export const isValidEmail = (email) => {
  // Regular expression for a simple email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email);
}